<template>
    <div class="p-6 pb-10 mb-15 shadow-md rounded-md">
        <h3 class="text-2xl font-bold">Prices</h3>
        <p class="text-base leading-5">
            Set the price ranges
        </p>
        <div class="mt-6">
            <form @submit.prevent="submit">
                <div class="lg:w-1/2">
                    <div v-if="form.hasErrors">
                        <ul class="mt-2 list-disc list-none text-xs text-red-600 dark:text-red-400">
                            <li v-for="(error, key) in form.errors" :key="key">{{ error }}</li>
                        </ul>
                    </div>
                    <div v-for="(price, index) in form.prices" class="custom-field mb-6">
                        <div class="range flex gap-3 items-end">
                            <div class="block text-sm">
                                <label class="block text-sm mb-2">
                                    <span class="text-lg font-semibold leading-6 mb-2.5">Min respondents</span>
                                </label>
                                <div class="relative">
                                    <jet-input type="number" min="0" step="1" v-model="price.min_respondents"
                                               class="block w-full"/>
                                </div>
                            </div>
                            <div class="block text-sm">
                                <label class="block text-sm mb-2">
                                    <span class="text-lg font-semibold leading-6 mb-2.5">Price per respondent</span>
                                </label>
                                <div class="flex relative">
                                    <div class="absolute mt-1 inset-y-0 left-0 px-3 flex items-center justify-center text-sm font-medium leading-5 text-gray-700 border-r border-light dark:border-gray-600 dark:text-gray-300 rounded-l-md">&pound;</div>
                                    <jet-input type="number" min="0" step="0.01" v-model="price.value"
                                               class="block w-full pl-10 rounded-r-md rounded-l-none"/>
                                </div>
                            </div>
                            <jet-secondary-button @click.prevent="removePrice(index)"
                                                  class="flex items-center justify-between ml-1 p-1 shadow-none text-sm font-medium leading-5 text-white transition-colors duration-150 bg-dark border border-transparent rounded-lg focus:bg-dark hover:bg-darkh dark:bg-gray-500 dark:hover:bg-gray-400">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                                     viewBox="0 0 24 24" stroke="white">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                </svg>
                            </jet-secondary-button>
                        </div>
                    </div>
                    <jet-button @click.prevent="addNewPrice" :has-icon="true" :bg-dark="true">
                        New Price
                    </jet-button>
                </div>
                <div class="flex justify-between items-center">
                    <jet-action-message :on="form.recentlySuccessful" class="ml-auto mr-3">
                        Saved.
                    </jet-action-message>
                    <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" :bg-dark="true">
                        Save fields
                    </jet-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import JetActionMessage from "@/Jetstream/ActionMessage";
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetInput from "@/Jetstream/Input";

export default {
    name: "SurveyPricesForm",
    components: {
        JetActionMessage,
        JetButton,
        JetSecondaryButton,
        JetInput,
    },
    props: {
        surveyType: {
            type: Number,
            required: true,
        },
        prices: {
            type: Array,
            default: [],
        }
    },
    setup(props) {
        const form = useForm({
            surveyType: props.surveyType,
            prices: props.prices || []
        });

        const addNewPrice = () => {
            form.prices.push({
                min_respondents: null,
                value: null,
            });
        };

        const removePrice = (index) => {
            form.prices.splice(index, 1);
        }

        const submit = () => {
            form.post(route('admin.unit-price.store'), {
                onSuccess: () => form.prices.sort((a, b) =>
                    (a.min_respondents > b.min_respondents) ? 1 : ((b.min_respondents > a.min_respondents) ? -1 : 0)
                )
            });
        }

        return {
            form,
            addNewPrice,
            removePrice,
            submit,
        }
    }
}
</script>

<style scoped>

</style>
